module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter Two")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“S")])])])]), _vm._v("o…can I get my room now?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam stood in the kitchen with Stella, watching as she put away the last of the breakfast dishes. The meal had been a success. The older couple from Florida and the honeymooners from Texas had all raved about the breakfast, all four of them fascinated and in awe as they asked Stella over and over how she’d pulled it off.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“First breakfast we’ve had in two days that wasn’t either burned or raw,” Mr. Gilchrest said with a wink. “Stella, did you find a new cookbook somewhere?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, just a new friend,” Stella told the senior citizen, her eyes glowing with pride while her father and her son looked on with that same pride.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you gonna keep him?” Joyce Gilchrest asked, her hazel eyes full of curiosity as she gave Adam the once-over.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella laughed and tossed her incredible hair. “I’m sure gonna give him that room he came looking for, you can count on that. Adam has to be exhausted after whipping up this great breakfast so lickety-split.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Joyce smiled over at Adam. “We’ve been coming here every spring for the last ten years. We miss Estelle, but we love Stella just about as much as we loved her mother. So we came back this year to lend her our support.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s mighty nice of you to be that loyal,” Adam said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We love it here,” Joyce replied. “I think you will, too. Don’t you think so, Wally?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wally Clark gave Adam a long appraising look that was part gratitude and part protectiveness. Stella’s father was a quiet man, unassuming and undemanding, but Adam sensed a steel-encased dignity behind the calm, stoic exterior.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hot Springs—you either love it or hate it,” Wally replied, his smile serene.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I liked those muffins,” Kyle offered up, his big eyes solemn. “But not the burned ones.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Kylie, finish your breakfast,” Stella said, turning red in the face. But she sent her son a sweet smile, all the same.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The honeymooners sitting across the dining room cooed and grinned, obviously too in love to expect anyone else to have problems in this life. “It was good,” the pretty blonde said, smiling over at her doting husband. “But then, I can hardly remember any of the meals anyway. We’re having so much fun.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I sure remember ’em,” Mr. Gilchrest replied with a grimace. “Had indigestion to remind me.” He chuckled then nodded toward Stella. “But I have very high hopes for our Stella. She’s gonna turn this place into a showcase one day.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam watched as Stella basked in the compliments. “This place has a lot of potential,” he said, sending her his own smile of confidence. “And so does the hostess.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella waved a hand in the air in dismissal. “Okay, now, don’t go giving me a big head. I still got a lot to learn. And the first rule—hire good help.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Amen,” Mr. Gilchrest said, lifting his coffee cup.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They all laughed out loud at that, including Adam.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now that everyone had been fed, and the guests had headed out to the festival, Stella bobbed her head in response to Adam’s question, her long hair cascading over her shoulder. “Papa’s putting fresh sheets on the downstairs bedroom right across from the parlor. It’s a smaller room near our private quarters, but it’s usually nice and quiet toward the front of the house. And we have a creditable library down there, too, if you like to read.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam lifted his head. “And far enough away from the stove?” At her confused look, he added, “Smoke.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Funny.” Then she looked down at the now-polished and shining butcher-block counter. “I want to thank you, Adam. I don’t know what I would have done this morning if you hadn’t come along. I’m good at multitasking, so I usually have things under control, but I might have taken on too much with this place. I’m not normally so emotional, but well…it just all hit me at once this morning. A lot has gone wrong around here since I took over. But I’m determined to make it work.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam could see that although she was pretty and petite, Stella Forsythe seemed to be carrying the weight of the world on her tiny shoulders. “You’re in a tough spot,” he said. “We just have to figure how to get you out of it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If I knew what I was doing, that might help,” she said with a self-deprecating snort. “My mother left me this place, and at first, I saw it as a new beginning. I’d been living hand to mouth up in Little Rock, working odds jobs here and there just to keep Kyle fed and clothed.” She shrugged, started gathering up dish towels. “My mother and I weren’t exactly close. She left us when I was young and I never forgave her. So I was shocked when I found out I’d inherited this old place. Shocked and amazed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She glanced around, her green eyes lifting toward the high ceiling of the kitchen. “I used to dream of living here with her. I got to visit her during the summer, but I wanted to live here all the time, with both my parents. My dad did the best he could, working hard to raise me, sending me to school, cooking dinner for us at night, helping me with my homework. But…I guess I needed my mama, too. That’s why I was crying this morning. I needed my mama.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam looked down at the aged wooden floor where the slant in the boards met in the middle of the big room with a soft sag. “That had to be tough. Why didn’t you live with her? I mean, fathers rarely win custody of a child.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella let out a soft chuckle, then shook her head. “My family doesn’t go by the book on such things. They never divorced, never consulted any lawyers. They just kind of agreed that I’d stay with Daddy. You see, he was the more solid of the two.” She started walking toward the little laundry room just off the kitchen. “My mother’s only passion was her art. She could paint a pretty picture, but she didn’t have a pretty life.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam didn’t question her anymore. She looked drained, washed out, defeated. “Uh…I guess I’ll go get a shower and some sleep.” At her nod, he stopped. “Stella, maybe we could negotiate an arrangement of sorts.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She lifted her slanted brows. “What kind of arrangement?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The question was asked with a not-so-subtle suspicion, as if she’d made arrangements before and lived to regret them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“In exchange for room and board, I could help out around here for a while. Fix things up, cook. I’m good at things like that—you know, fixing up, cleaning up and cooking.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam hated the plea in his voice, but he didn’t want to leave the Sanctuary Inn just yet. Something about the needy old house had captivated him. Or maybe it was something about the need he saw in the woman standing beside him that had captivated him. Besides, he wasn’t intent on going anyplace in a hurry. He’d come here to get as far away as possible from his past and his old life. Why not stay awhile and just…rest?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella looked at him as if he might be crazy, her eyes going wide, her mouth opening and then closing. “You’d be willing to do all that just for a place to sleep?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure. Don’t get me wrong. I’m not destitute. But I am on a budget, being retired and all. And it’d just be until I can find…until I can decide what to do next.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She stood with her foot propped against the partially open door to the laundry room, the bundle of towels in her hands. “I’ll have to discuss it with Papa and Kyle, but I think we might be able to work something out. I mean, if you can make meals like the one you made this morning and help me get this place back into shape, well, who am I to turn you away?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can fix that oven, too,” he reminded her. “Easy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then you’ve got a job.” She named her terms. “Room and board—and a weekly salary—I insist on paying you for your time and trouble.” She told him what the last maintenance man got paid. “Is that reasonable?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“More than reasonable. Thank you,” Adam said, no other words available. It had been a long time since anyone had just accepted him. But then, he figured Stella had just about reached the end of the road, same as he had. “I’m going to my room now. I guess I’ll see you later.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, later,” she said, her expression puzzled and questioning. She turned to head into the laundry room, then whirled back around. “Adam?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hmm?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why are you here?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam braced one hand on the swinging door opposite her, wondering how to answer that very loaded question. “It’s the first place I saw that had a vacancy,” he said. “Seemed like a good place to lay my head.” And before she could question him again, he turned and went through the swinging door, the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("swish, swish")])]), _vm._v(" of it moving behind him, sending little currents of air chasing at his retreating back.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella went about the business of getting all the linens washed. This work she didn’t mind so much. This work had meaning. Washing away the old, bringing out the fresh and clean. She liked to fold the sheets and towels just out of the dryer, the smell of sunshine and tropical breezes making her put her nose to the crisp white linens.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At least her mother had had the good sense to buy nice linens. Or maybe it had been Mrs. Ebard. Mrs. Ebard and her husband had managed the Sanctuary up until the day Stella had taken over. Tired and old and cranky, the married couple couldn’t wait to leave and be done with the falling-down old house. Stella remembered Louise Ebard’s words to her the day she’d called to tell Stella that Estelle Forsythe had died.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She just went to sleep and never woke up. Heart attack. At fifty-five. And her a little skinny thing, at that. ’Course, it might have been the smoking and drinking or the late nights out in that studio, who knows.” After much sniffing and crying, Mrs. Ebard had added, “She wanted you to have the inn, honey. Told me long ago—that’s in her will. But I have to tell you, things are bad here. It’s a bit run-down. We don’t get many visitors except the ones that have been coming here for years. Just the regulars or the occasional traveler who can’t find anything better. I still cook and Ralph works on the yard and house, but we can’t keep at this anymore. It’s just bad.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Really bad,” Stella said now, hearing the sound of her son’s laughter out in the back garden. Her daddy was out there with Kyle, trying to clip the wisteria back before it took over the studio. Her mother had loved wisteria. But as beautiful as the purple, scented blossoms were this time of year, Stella knew even wisteria, left untamed, eventually suffocated everything in its path. The same way her mother had filled a room and suffocated everyone and everything in it, taking over, demanding, manipulating, the sweet scent of her perfume mixed with the charcoal smell of cigarettes wafting through the air until Stella would almost choke with the pain and grief of not measuring up, of not understanding that her mother was both brilliant and a bit mad.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Flighty.” That’s what her father had called his Estelle. Flighty and scatterbrained and tormented and talented. Not a woman made for maternal instincts, not a woman made to stay with one man. Not a woman to want her only daughter to bother her when she was working. One simple, hardworking man and one small, scared little girl, left behind, with only the scent of wisteria to comfort them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And yet, they’d both willingly come here to the home where the woman they’d loved had lived alone amongst strangers. And died alone, all of her guests gone. Maybe they were each hoping to catch a bit of Estelle’s elusive spirit, to be near the places she’d been near, to touch the things she’d touched.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella hoped her father tamed that wisteria vine, once and for all. And she had to wonder for the hundredth time "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("why")])]), _vm._v(" she’d even bothered coming here. Did she want to be reminded of all that her mother had given up in order to have her freedom, her art? Did she want to be here so she could remember, or had she brought her son and her father here to start over, to forget?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Daddy would tell her to put her trust in God. Daddy was a good, Christian man with a solid work ethic, but he’d had his heart broken long ago. Had that been a part of God’s grand plan for him?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stubbornly, Stella put her nose to a white lace-trimmed pillowcase, closing her eyes to take in the freshness of it. New, clean, washed. She prayed God would one day make her feel that way. And then she thought about Adam Callahan and wondered what his story was. What was he running from, to come here to this sad old house, to ask to be able to stay here? He’d called the Sanctuary a good place to lay his head. Maybe he was right there. It certainly was a place for confused, wayward travelers. Even if some of those travelers thought they were coming home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mama, why you got your nose in that pillow cover?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her son’s words jarred Stella out of her musings. Opening her eyes, she tried to focus. “Oh, I was just enjoying the nice smell.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Papa and me are thirsty. He sent me for lemonade. That store-bought stuff is pretty good. Papa said we can keep buying it, since the last time we tried to make it fresh, you poured the juice down the drain by accident.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella remembered. Five crushed lemon rinds and no juice to show for it, since she’d somehow managed to pour out the juice instead of the rinds. “I kind of got things backward that day, didn’t I?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kyle grinned. “It’s okay. The kind we get at the store is powdery and already squeezed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella looked down at her child, her heart unfolding toward him with a maternal surge of hope and pride. She loved her son, had loved him enough to fight for him, and she couldn’t imagine leaving him, ever. His daddy had been bad to the bone, but so good-looking and persuasive, so intense, that Stella had somehow overlooked that one big flaw. Stella had married Lawrence Forsythe on an impulsive whim, tinged with a passionate need to love and be loved.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But their son, ah, their son was priceless, as perfect and pure as a fine piece of porcelain. As sturdy and strong as the timbers in this old house. He’d had to grow up too fast after his father’s death, but soon Kyle would have better. Kyle would survive and thrive, because Stella had her father here to guide him. And in spite of her own bent toward wanting to paint pretty pictures on everything from benches to teacups, Stella had to be practical and sure. She had to work to get this place back up and running. For Kyle’s sake. She wanted to be the one to take care of her son, not the other way around.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kyle had a keen sense of responsibility. Her father called him an old soul. But Stella didn’t want him to miss out on just being a child. She’d had to grow up too quickly in order to take care of her mother at times. Kyle wouldn’t have to do that.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And that meant she certainly wouldn’t look a gift horse in the mouth and turn him away. Adam Callahan had offered to help out. Stella, being practical in spite of her artistic side, aimed to take him up on that offer. Just as soon as she explained things to her father and her son, of course.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam heard laughter. Maybe he was dreaming, but the sound brought him a kind of gentle peace. The laughter floated through his subconscious mind, reminding him of lazy days spent fishing with his father and brothers out on the bayou, of time spent riding the big boat out on Lake Pontchartrain, good times. Happy times. Laughter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He woke with a start, wondering where he was. He was hot and sweaty, his brow wet, his pulse pounding. Lifting his head, he slowly glanced around the darkened room, his gaze taking in the shiny mahogany armoire, the old-fashioned washstand with the white bowl and pitcher, the four-poster bed with the soft, fresh sheets and the rose-quilted cover. Sanctuary.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was at the Sanctuary House Inn in Hot Springs, Arkansas. Hundred of miles away from New Orleans. A million miles away from his past. Had he come far enough?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam got up and took a long shower, enjoying the soft spray as he reminded himself to check the pressure later. The old claw-foot bathtub was respectable, even if it was ancient, but the shower could use a few tweaks. Maybe he’d install one of those fancy newfangled showerheads. That would certainly be a plus for guests.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He got dressed, his mind already at work as he made a mental note of all the things he’d noticed around this place that needed to be fixed. Shutters that needed to be repaired and repainted. Porch steps that needed to be straightened and steadied. Rugs cleaned, trees trimmed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was already out in the hallway across from the dark paneled library when it hit him that somehow in the space of about six hours and several sweet dreams, he’d made a commitment to a place he didn’t even know. And to a woman he surely didn’t even begin to understand. Not a good idea. Not good at all. What if things became all tangled, like the ivy vine growing down on the sign post? He might just have to tell Stella that he’d changed his mind, that he couldn’t stay after all.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But then, Adam came down the steps leading to the back gardens and stopped, his heart slamming against his chest, his breath halting in his lungs as he watched the scene playing out before him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mr. Clark sat in an old rusty wrought iron lawn chair, gently rocking it back and forth, while Stella and Kyle laughed and moved around in the un-mowed wildflower clusters at the back end of the long, wide yard. They were playing ring-around-the-rosy. The afternoon sun surged around them like a halo, all bright and white and piercing. Kyle looked up, giggling, as his mother held his hands, skipping in a circle with him, her long, bright hair falling down toward the floral skirt of her dress. Stella threw her head back, laughing, teasing, while Kyle squealed with delight as they swirled faster and faster in the red clovers and tiny wild onion flowers, daffodils and black-eyed Susans frolicking in the wind right in step with them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam held on to the porch rail, his eyes tightening against the too-bright swell of emotions filling his insides. Once long ago, he’d dreamed of just such a picture in his own life. But his job had eaten away at any intimacy, any type of happiness he might have found. He’d loved and left a lot of women, or more likely, they’d loved him and he’d left them. The job had always taken what little soul he had to give. And in the end, the job had taken all of him, all of his strength, all of his energy, all of his dreams. Adam had been too involved in real life to have any dreams in his own life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But standing here now, watching the sweetness of a simple spring afternoon, hearing the drone of bumblebees on the rosebushes and the fussing and chirping of mockingbirds up in the big old live oak just beyond the house, and seeing this woman and her child playing with joy and abandon in the flower-filled yard of an old house that seemed to sigh in its contentment, Adam thought again about his dreams. And his torments. And he wished he could play with them, wished he could laugh out loud again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But he couldn’t move. So he just stood there, watching, observing, with all of his cop instincts on full-throttle warning, while his heart sent out a warning of its own. Turn away, it told him inside each erratic beat. Don’t dream. It hurts too much. But he couldn’t turn away. He just couldn’t. The image of Stella and Kyle laughing and playing would stay with him for a very long time to come, like a faded picture held just out of his reach, a sweet reminder of all that was good and great in life. A reminder of all that he would never have.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then Stella stopped skipping and fell down into the wildflowers, giggling as Kyle fell with her. She lifted her head, taking a breath, and saw Adam standing there. Her eyes held his, a soft surprised smile on her pink lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And she called out to him. “Adam, come and join us.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Adam Callahan closed his eyes, images of death and crime, of drugs and killers and abuse and anger, moving through his tired, jaded brain to remind him that he’d dropped out of life. He’d once been a good cop. But then, he’d done something to change all of that. It didn’t matter that he was only trying to save a family member, it was still wrong. So wrong that Adam hadn’t used good judgment. Now he was paying for that with this self-imposed exile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Adam?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stella’s soft, melodious call seemed to push away all the dark-edged ugliness he’d seen in his head. Adam opened his eyes, smiled at her, then slowly starting walking through the overgrown garden toward the source of all that laughter and sunshine.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1792c478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mountainsanctuary_ch02.vue
// module id = 69
// module chunks = 0